import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearActiveObject, clearActiveObjects, clearLeftWorkAreaState } from '../../redux/actions/product2dActions';

export const useLayerSettings = ()=>{
    const makFabric = useSelector((state:any) => state.makFabric)
    const activeObj = useSelector((state:any) => state.activeObj)
    const activeObjs = useSelector((state:any) => state.activeObjs)

    const dispatch = useDispatch()

    return {
        delete:{
            onClick: ()=>{
                makFabric.removeObjects()
                //todo: determine what does this do:
                dispatch(clearLeftWorkAreaState())
                
                dispatch(clearActiveObject())
                dispatch(clearActiveObjects())
            }
        },
        duplicate: {
            onClick: () => { makFabric.copyObject(activeObj) },
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        flip_v: {
            onClick: () => { makFabric.flipYObjects() },
        },
        flip_h:{
            onClick: () => { makFabric.flipXObjects() },
        },
        alignLeft:{
            onClick: () => { makFabric.alignObjects("LEFT") },
        },
        alignRight:{
            onClick: () => { makFabric.alignObjects("RIGHT") },
        },
        alignCenter:{
            onClick: () => { makFabric.alignObjects("CENTER") },
        },
        alignTop:{
            onClick: () => { makFabric.alignObjects("TOP") },
        },
        alignBottom:{
            onClick: () => { makFabric.alignObjects("BOTTOM") },
        },
        bringToFront:{
            onClick: () => { makFabric.bringToFrontObjs() },
        },
        sendToBack:{
            onClick: () => { makFabric.sendToBackObjs() },
        }

    }

}